import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        versionId: '=',
        courseId: '=',
        versionName: '=',
        isCourseWithMaterials: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'course.Copy version' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'course.Version name' | translate }}*</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row ng-if="vm.isCourseWithMaterials">
                        <span class="label">{{ 'courses.Disable access to study materials in version to be copied' | translate }} ({{ vm.versionName }})</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label><input type="checkbox" ng-model="vm.isStudyMaterialRestricted" checked></label>
                                </li>
                            </ul>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.courseId">
                        <form-row-error></form-row-error>
                    </form-row>
                    <form-row error="vm.form.errors.versionId">
                        <form-row-error></form-row-error>
                    </form-row>
                    <p>{{ 'course.New personal deadline message' | translate }}</p>
                    <form-row>
                        <label class="label">{{ 'course.Sites' | translate }}</label>
                        <div class="items"><p>{{ vm.sites }}</p></div>
                    </form-row>
                    <form-row error="vm.form.errors.personalDeadline">
                        <label class="label">{{ 'course.New personal deadline' | translate }}</label>
                        <div class="items">
                            <datepicker-api ng-model="vm.form.model.personalDeadline"/>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
                <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button ng-if="vm.showSaveButton" class="btn main" type="button" ng-click="vm.save()">{{ 'general.Copy' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($scope, $translate, FormFactory, CourseVersionResource,
                 SiteService, PrivilegeService, ROLE_PRIVILEGE_ENUM) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.CourseVersionResource = CourseVersionResource;
        this.SiteService = SiteService;
        this.PrivilegeService = PrivilegeService;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
    }

    $onInit () {
        this.showSaveButton = true;
        this.isStudyMaterialRestricted = false;
        this.version = new this.CourseVersionResource({
            versionId: this.versionId,
            courseId: this.courseId
        });
        this.form = this.FormFactory.create(this.version, model => model.$save());
        if (this.PrivilegeService.isCompanyAdmin()) {
            this.sites = this.$translate.instant('course.All sites');
        }
        else {
            this.sites = this.SiteService.getSitesByPrivileges(
                [this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_MANAGE]
            ).map((site) => site.name).join(', ');
        }
    }

    save () {
        this.showSaveButton = false;
        this.form.model.isStudyMaterialPublic = !this.isStudyMaterialRestricted;
        this.form.save()
            .then(version => this.uibModalInstance.close(version))
            .catch(() => {
                this.showSaveButton = true;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/version/copy/index.js